import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const faqs = [
  {
    q: "İstanbul'a gitmek için en iyi zaman hangisi?",
    a: "İstanbul'u ziyaret etmek için en ideal dönemler Nisan–Haziran ve Eylül–Kasım aylarıdır. Bu dönemlerde hava ılıman, kalabalık görece az ve turistik mekanlar daha keyifli olur. Temmuz–Ağustos sıcak ve kalabalık olabilir; Aralık–Şubat ise soğuk ama daha sakin bir İstanbul sunar.",
  },
  {
    q: "İstanbul'da kaç gün geçirmek gerekir?",
    a: "İstanbul'un tarihi yarımadasını (Sultanahmet, Kapalıçarşı, Topkapı Sarayı) görmek için en az 3 gün gerekir. Boğaz turu, Beyoğlu, Kadıköy ve Adalar gibi semtleri de eklerseniz 5–7 gün ideal bir süre olacaktır. İstanbul'u gerçekten keşfetmek isteyenler için 10 gün bile yetmez.",
  },
  {
    q: "İstanbul'da mutlaka görülmesi gereken yerler hangileri?",
    a: "Ayasofya, Topkapı Sarayı, Kapalıçarşı, Sultanahmet Camii (Mavi Cami), Dolmabahçe Sarayı, Galata Kulesi, Boğaz turu, Balat semti ve Prens Adaları İstanbul'un mutlaka görülmesi gereken yerleri arasındadır. Bunların yanı sıra Beylerbeyi Sarayı, Çırağan Sarayı ve Rumeli Hisarı da ziyaret listesine eklenebilir.",
  },
  {
    q: "İstanbul'da ulaşım nasıl sağlanır?",
    a: "İstanbul'da ulaşım için İstanbulkart kullanmanızı öneririz. Metro, tramvay, metrobüs, vapur ve otobüs gibi tüm toplu taşıma araçlarında geçerlidir. Tarihi yarımadada tramvay (T1 hattı) oldukça kullanışlıdır. Boğaz'ın iki yakısı arasında vapur seferleri de hem pratik hem de keyiflidir.",
  },
  {
    q: "İstanbul'da nerede konaklayabilirim?",
    a: "Sultanahmet, tarihi mekanlara yürüme mesafesinde olması nedeniyle ilk kez gelenlere idealdir. Beyoğlu (Taksim, Cihangir, Galata) daha kozmopolit ve canlı bir atmosfer sunar. Kadıköy ise yerel yaşamı hissetmek isteyenler için mükemmeldir. Bütçenize göre butik otellerden lüks zincir otellere kadar geniş bir yelpaze mevcuttur.",
  },
  {
    q: "İstanbul'da ne yenilmeli?",
    a: "İstanbul'da mutlaka tatmanız gereken lezzetler: balık ekmek (Eminönü), simit, midye dolma, kokoreç, döner, Kapalıçarşı'da Türk lokumu ve Mısır Çarşısı'nda baharatlar. Kadıköy'ün sokak lezzetleri ve Beyoğlu'nun meyhane kültürü de ayrı bir deneyim sunar.",
  },
  {
    q: "İstanbul'da Boğaz turu nasıl yapılır?",
    a: "Boğaz turu için en ekonomik seçenek Şehir Hatları vapurlarıdır; Eminönü veya Beşiktaş'tan kalkar ve Anadolu yakısına kadar uzanır. Özel tekne turları ise daha kapsamlı ve özelleştirilebilir deneyimler sunar. Gün batımında yapılan Boğaz turları özellikle tavsiye edilir.",
  },
  {
    q: "İstanbul'da alışveriş için en iyi yerler nereler?",
    a: "Kapalıçarşı (dünyanın en büyük kapalı çarşılarından biri), Mısır Çarşısı (baharatlar ve kuruyemişler), Nişantaşı (lüks markalar), Bağdat Caddesi (butik mağazalar) ve Kadıköy Çarşısı (yerel ürünler) İstanbul'un en popüler alışveriş noktalarıdır.",
  },
  {
    q: "İstanbul'da güvenlik nasıl?",
    a: "İstanbul genel olarak güvenli bir şehirdir. Turistik bölgelerde yankesicilere karşı dikkatli olunması önerilir. Sultanahmet ve Taksim gibi kalabalık alanlarda çantanıza dikkat edin. Gece geç saatlerde ıssız sokaklardan kaçınmak ve lisanslı taksi veya uygulamalar üzerinden araç çağırmak güvenliğinizi artırır.",
  },
  {
    q: "İstanbul'dan günübirlik gezi yapılabilecek yerler var mı?",
    a: "İstanbul'dan günübirlik yapılabilecek en popüler destinasyonlar: Bursa (Uludağ ve Osmanlı mirası), Edirne (Selimiye Camii), Sapanca ve Abant (doğa), Şile ve Ağva (plaj ve kamp), İznik (tarihi surlar ve çiniler) ile Prens Adaları'dır. Hepsi 1–2 saat mesafededir.",
  },
  {
    q: "İstanbul'da hangi müzeler mutlaka ziyaret edilmeli?",
    a: "Topkapı Sarayı Müzesi, Ayasofya, İstanbul Arkeoloji Müzeleri, Türk ve İslam Eserleri Müzesi, Pera Müzesi, İstanbul Modern ve Sakıp Sabancı Müzesi İstanbul'un en önemli müzeleri arasındadır. Müze kartı alarak tüm devlet müzelerine tek biletyle girebilirsiniz.",
  },
  {
    q: "İstanbul'da Avrupa ve Asya yakası arasındaki fark nedir?",
    a: "Avrupa yakası tarihi ve turistik mekanların büyük çoğunluğunu barındırır (Sultanahmet, Beyoğlu, Beşiktaş). Asya yakası ise daha yerel, sakin ve otantik bir İstanbul deneyimi sunar; Kadıköy, Moda ve Bağdat Caddesi bu yakının öne çıkan semtleridir. Vapur ile iki yakı arasında geçiş yapmak başlı başına keyifli bir deneyimdir.",
  },
];

const IstanbulFaq = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  useEffect(() => {
    const title = "İstanbul Seyahat SSS — Sık Sorulan Sorular ve Cevaplar 2026";
    const desc = "İstanbul'a seyahat planlayanlar için en sık sorulan sorular: en iyi zaman, gezilecek yerler, ulaşım, konaklama, yeme-içme ve güvenlik hakkında kapsamlı rehber.";
    document.title = title;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    const setCanonical = (url: string) => {
      let el = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (!el) { el = document.createElement("link"); el.setAttribute("rel", "canonical"); document.head.appendChild(el); }
      el.setAttribute("href", url);
    };
    const injectSchema = (id: string, data: object) => {
      let el = document.getElementById(id);
      if (!el) { el = document.createElement("script"); el.id = id; el.setAttribute("type", "application/ld+json"); document.head.appendChild(el); }
      el.textContent = JSON.stringify(data);
    };

    setCanonical("https://geziturkiyem.com/istanbul-sss");
    setMeta("description", desc);
    setMeta("keywords", "istanbul seyahat, istanbul gezilecek yerler, istanbul sss, istanbul rehberi, istanbul ne zaman gidilir, sultanahmet gezilecek yerler, topkapi sarayi, ayasofya, galata kulesi, beyoglu, kadikoy, uskudar, adalar, bogaz turu, istanbul tarihi yarimada, istanbul kapalicarsisi, istanbul konaklama, istanbul restoranlar, istanbul ulasim, istanbul gunubirlik gezi, istanbul muzeler, istanbul alisveris, istanbul guvenlik, istanbul avrupa yakasi, istanbul asya yakasi, istanbul taksim, istanbul besiktas, istanbul sile agva, istanbul polonezkoyu");
    setMeta("og:title", title, true);
    setMeta("og:description", desc, true);
    setMeta("og:type", "article", true);
    setMeta("og:url", "https://geziturkiyem.com/istanbul-sss", true);
    setMeta("og:image", "https://readdy.ai/api/search-image?query=Istanbul%20Bosphorus%20view%20Hagia%20Sophia%20Blue%20Mosque%20Galata%20Tower%20city%20skyline%20sunset%20Turkey&width=1200&height=630&seq=ist-sss-og&orientation=landscape", true);
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title);
    setMeta("twitter:description", desc);

    injectSchema("schema-istanbul-faq", {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqs.map((f) => ({
        "@type": "Question",
        "name": f.q,
        "acceptedAnswer": { "@type": "Answer", "text": f.a },
      })),
    });

    injectSchema("schema-istanbul-breadcrumb", {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "Ana Sayfa", "item": "https://geziturkiyem.com/" },
        { "@type": "ListItem", "position": 2, "name": "İstanbul SSS", "item": "https://geziturkiyem.com/istanbul-sss" },
      ],
    });

    return () => {
      document.title = "Türkiye Seyahat Rehberi";
      const s1 = document.getElementById("schema-istanbul-faq");
      const s2 = document.getElementById("schema-istanbul-breadcrumb");
      if (s1) s1.remove();
      if (s2) s2.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <div className="relative pt-20 pb-16 overflow-hidden bg-stone-900">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Istanbul%20Bosphorus%20panoramic%20view%20Hagia%20Sophia%20Blue%20Mosque%20Galata%20Tower%20city%20skyline%20golden%20sunset%20Turkey%20aerial&width=1400&height=500&seq=ist-sss-hero&orientation=landscape"
            alt="İstanbul"
            className="w-full h-full object-cover object-top opacity-30"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
        </div>
        <div className="relative max-w-3xl mx-auto px-4 md:px-8 text-center">
          <nav className="flex items-center justify-center gap-2 text-xs text-stone-400 mb-5">
            <Link to="/" className="hover:text-white transition-colors">Ana Sayfa</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-white">İstanbul SSS</span>
          </nav>
          <span className="inline-block bg-amber-500/20 border border-amber-400/30 text-amber-300 text-xs font-semibold px-4 py-1.5 rounded-full mb-4 uppercase tracking-widest">
            Sık Sorulan Sorular
          </span>
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
            İstanbul Seyahat Rehberi
          </h1>
          <p className="text-stone-300 text-sm max-w-xl mx-auto">
            İstanbul'a seyahat planlayanların en çok merak ettiği sorular ve kapsamlı cevapları.
          </p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 md:px-8 py-14">
        {/* Intro */}
        <div className="bg-amber-50 border border-amber-100 rounded-2xl p-6 mb-10">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-xl flex-shrink-0">
              <i className="ri-map-pin-2-line text-amber-600 text-xl"></i>
            </div>
            <div>
              <h2 className="font-bold text-stone-900 mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>
                İstanbul Hakkında
              </h2>
              <p className="text-stone-600 text-sm leading-relaxed">
                İki kıtayı birleştiren, 15 milyonu aşkın nüfusuyla dünyanın en büyük şehirlerinden biri olan İstanbul; Ayasofya, Topkapı Sarayı ve Boğaz manzarasıyla her yıl milyonlarca ziyaretçiyi ağırlamaktadır. Aşağıda İstanbul seyahati hakkında en sık sorulan soruları ve cevaplarını bulabilirsiniz.
              </p>
            </div>
          </div>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className={`border rounded-2xl overflow-hidden transition-all duration-200 ${
                openIndex === i ? "border-amber-300 bg-amber-50/50" : "border-stone-100 bg-white hover:border-stone-200"
              }`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer"
              >
                <h4 className={`font-semibold text-sm leading-snug pr-4 ${openIndex === i ? "text-amber-800" : "text-stone-900"}`}>
                  <a id={`sss-${i + 1}`} className="scroll-mt-20">{faq.q}</a>
                </h4>
                <div className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all ${
                  openIndex === i ? "bg-amber-500 text-white rotate-180" : "bg-stone-100 text-stone-500"
                }`}>
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-6 pb-5">
                  <p className="text-stone-600 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Related Links */}
        <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 gap-4">
          <Link to="/kapadokya-sss" className="group flex flex-col gap-2 p-5 bg-stone-50 border border-stone-100 rounded-2xl hover:border-amber-200 transition-all">
            <div className="w-8 h-8 flex items-center justify-center bg-stone-200 group-hover:bg-amber-100 rounded-xl transition-colors">
              <i className="ri-landscape-line text-stone-600 group-hover:text-amber-600 text-sm"></i>
            </div>
            <p className="font-semibold text-stone-900 text-sm">Kapadokya SSS</p>
            <p className="text-xs text-stone-400">Peri bacaları ve balon turları hakkında</p>
          </Link>
          <Link to="/antalya-sss" className="group flex flex-col gap-2 p-5 bg-stone-50 border border-stone-100 rounded-2xl hover:border-amber-200 transition-all">
            <div className="w-8 h-8 flex items-center justify-center bg-stone-200 group-hover:bg-amber-100 rounded-xl transition-colors">
              <i className="ri-sun-line text-stone-600 group-hover:text-amber-600 text-sm"></i>
            </div>
            <p className="font-semibold text-stone-900 text-sm">Antalya SSS</p>
            <p className="text-xs text-stone-400">Akdeniz tatili için rehber</p>
          </Link>
          <Link to="/places" className="group flex flex-col gap-2 p-5 bg-stone-50 border border-stone-100 rounded-2xl hover:border-amber-200 transition-all">
            <div className="w-8 h-8 flex items-center justify-center bg-stone-200 group-hover:bg-amber-100 rounded-xl transition-colors">
              <i className="ri-map-2-line text-stone-600 group-hover:text-amber-600 text-sm"></i>
            </div>
            <p className="font-semibold text-stone-900 text-sm">Tüm Mekanlar</p>
            <p className="text-xs text-stone-400">Türkiye'nin tüm destinasyonları</p>
          </Link>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default IstanbulFaq;
